import { useEffect, useState } from 'react'

// Page-number cell counts per screen size (passed to buildPageItems as maxItems): roomy desktop
// shows the full first/last + ellipsis set, medium a compact window, small just the current page.
const BIG_SLOTS = 6
const MEDIUM_SLOTS = 3
const SMALL_SLOTS = 1

const BIG_MIN_QUERY = '(min-width: 1280px)'
const MEDIUM_MIN_QUERY = '(min-width: 820px)'

const hasMatchMedia = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

const computeSlots = (): number => {
    if (!hasMatchMedia()) return BIG_SLOTS
    if (window.matchMedia(BIG_MIN_QUERY).matches) return BIG_SLOTS
    if (window.matchMedia(MEDIUM_MIN_QUERY).matches) return MEDIUM_SLOTS
    return SMALL_SLOTS
}

/** Number of page-number cells the pagination should render, by viewport width. */
export const usePaginationSlotCount = (): number => {
    const [slots, setSlots] = useState<number>(computeSlots)

    useEffect(() => {
        if (!hasMatchMedia()) return
        const queries = [window.matchMedia(BIG_MIN_QUERY), window.matchMedia(MEDIUM_MIN_QUERY)]
        const update = () => setSlots(computeSlots())
        queries.forEach((q) => q.addEventListener('change', update))
        return () => queries.forEach((q) => q.removeEventListener('change', update))
    }, [])

    return slots
}
